exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-dropzone[data-v-2d3b8e37] {\n  border: none;\n  text-align: center;\n}\n.vue-dropzone[data-v-2d3b8e37] {\n  background: #eee;\n  border: thin dashed #666;\n  padding: 0;\n  margin: 0;\n  min-height: inherit;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.vue-dropzone .dropzone-custom-title[data-v-2d3b8e37] {\n  margin: 0;\n}\n.file-wrapper[data-v-2d3b8e37] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.a-file-search[data-v-2d3b8e37] {\n  font-size: 20px;\n}", ""]);

// exports
